import { useRef } from "react";

export default function useSyncRef(target) {
  const ref = useRef(target);

  ref.current = target;

  return ref;
}
